// Angular
import { Component, Input, OnInit, NgModuleFactoryLoader } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
import { take,tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User, authRole, AuthService } from '../../../../../core/auth';
import { ENUM } from '../../../../../core/enum/enum';
import { LogoutDialogComponent } from '../../../content/crud/index';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user$: Observable<User>;
	userRole;
	Enum = ENUM;
	@Input() avatar: boolean = true;
	@Input() greeting: boolean = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>,
		private dialog: MatDialog,
		private authService:AuthService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(currentUser));
		this.store.select(authRole).pipe(tap(role => {
           this.userRole = +role;
		})).subscribe();
	}

	/**
	 * Log out
	 */
	logout() {
	 this.store.select(authRole).pipe(take(1)).subscribe((role) => {
			if(role == ENUM.roles.CASHIER){
				let dialogRef = this.dialog.open(LogoutDialogComponent,{data:{}});
				dialogRef.afterClosed().subscribe((val) => {
                   if(!!val){
					 this.authService.signoutCashier(val.amount).subscribe((res) => {
						 this.store.dispatch(new Logout());
					 })
				   }
				});
			}else{
				this.authService.signout().subscribe((res) => {
					this.store.dispatch(new Logout());
				})
			}
		})
	}

}
